var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      {
        staticClass: "jade-alert",
        class: _vm.computedClass,
        attrs: { role: "alert" },
      },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        { staticClass: "jade-alert__main", class: _vm.computedClassMain },
        [
          _vm.showIcon
            ? _c("jade-icon", {
                attrs: { size: "medium", use: _vm.computedIcons },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "jade-alert__content" },
            [
              _vm.title
                ? _c(
                    "jade-text",
                    {
                      attrs: {
                        variant: "text-medium",
                        weight: "semibold",
                        color: "current-color",
                        "data-testid": "text-title",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.title) + " ")]
                  )
                : _vm._e(),
              _vm.$slots.default
                ? _c(
                    "jade-text",
                    {
                      attrs: {
                        variant: "text-medium",
                        weight: "regular",
                        color: "current-color",
                        "data-testid": "text-default",
                      },
                    },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm.link
                ? _c(
                    "jade-link",
                    {
                      attrs: {
                        href: _vm.$sanitize(_vm.link.href),
                        rel: _vm.link?.rel,
                        target: _vm.link?.target,
                        variant: _vm.variant,
                        "data-testid": "jade-link",
                      },
                      on: { click: _vm.handleLinkClick },
                    },
                    [_vm._v(" " + _vm._s(_vm.link.text) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.onDismiss
        ? _c(
            "div",
            { staticClass: "jade-alert__dismiss" },
            [
              _c("jade-icon-button", {
                attrs: {
                  icon: "close",
                  variant: "neutral-ghost",
                  size: "medium",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("onDismiss")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }